import { BASE_API_URL } from "@/api/urls/apiUrls";
import axios from "axios";
import cookie from "js-cookie";

const axiosInstance = axios.create({
  baseURL: BASE_API_URL,
});

/* ------------------- create a interceptors of axios ------------------- */
axiosInstance.interceptors.request.use(
  (config) => {
    const token = cookie.get("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    config.headers["ngrok-skip-browser-warning"] = "true";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only handle auth errors globally, let component-level handlers deal with other errors
    if (error.response && error.response.status === 401) {
      // console.log("401 Unauthorized error detected");
      // Redirect logic here if needed
    }

    // For debugging - log all errors but don't modify them
    // console.log("Axios interceptor caught error:", error.response?.status, error.message);

    // Important: Always reject with the original error structure intact
    return Promise.reject(error);
  },
);

export default axiosInstance;
